import { alpha } from '@mui/material/styles'

export const grey = {
  0: '#FFFFFF',
  50: '#fcf8ff',
  100: '#f6f2ff',
  200: '#f0ebfe',
  300: '#e4e0f3',
  400: '#c8c4d2',
  500: '#787582',
  600: '#5d5b68',
  700: '#474551',
  800: '#302f3d',
  900: '#1b1a27',
  950: '#12111a',
  light: '#e4e0f3',
  main: '#787582',
  dark: '#474551',
}

const common = {
  black: '#000000',
  white: '#FFFFFF',
}

export const primary = {
  lighter: '#8E87DB',
  main: '#5A53A3',
  dark: '#433C8A',
}

const action = {
  hover: alpha(grey[500], 0.08),
  selected: alpha(grey[500], 0.16),
  disabled: alpha(grey[500], 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
  active: grey[400],
}

const base = {
  primary,
  grey,
  common,
  divider: alpha(grey[500], 0.2),
  action,
}

export function palette(mode) {
  if (mode === 'dark') {
    return {
      mode: 'dark',
      text: {
        primary: grey[50],
        secondary: grey[400],
        disabled: grey[600],
        icon: grey[50],
      },
      background: {
        default: grey[950],
        paper: grey[900],
        neutral: grey[200],
      },
      ...base,
    }
  }

  return {
    mode: 'light',
    text: {
      primary: grey[950],
      secondary: grey[700],
      disabled: grey[500],
      icon: alpha(grey[800], 0.8),
    },
    background: {
      default: grey[50],
      paper: common.white,
      neutral: grey[200],
    },
    ...base,
  }
}
